import React from 'react';

const phrases = [
  'Available For Freelance',
  'Full Stack Developer',
  'Website Designer',
  'React + Node Specialist',
  'AI Integration',
  'Based in Hyderabad',
  'Remote Worldwide',
  'Premium Web Experiences'
];

function Marquee() {
  const items = [...phrases, ...phrases];

  return (
    <section
      aria-label="Available services marquee"
      className="relative overflow-hidden border-y border-ink/10 bg-coal py-6 text-white"
    >
      <div className="marquee-track flex min-w-full whitespace-nowrap">
        {items.map((phrase, i) => (
          <span
            key={`${phrase}-${i}`}
            className="mx-8 inline-flex items-center gap-8 font-display text-2xl font-bold uppercase tracking-[-0.01em] md:text-4xl"
          >
            {phrase}
            <span className="inline-block h-2 w-2 rounded-full bg-accent" aria-hidden="true" />
          </span>
        ))}
      </div>
    </section>
  );
}

export default Marquee;
